export const BASE_URI =
    process.env.NODE_ENV === "development" ? "http://localhost:8000/api" : "https://vcreate.io/api";

export const AUTH_TOKEN_STORAGE_KEY = "mhcattention_access_token";
export const TAPIR_BASE_PATH = "/tapir";
export const TAPIR_PASSWORD_RESET_URL = `${TAPIR_BASE_PATH}/request_password_reset`;

export function prettyPrintDate(dateString: string): string {
    const parsed = new Date(dateString);
    if (!Number.isNaN(parsed.getTime())) {
        return parsed.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    }

    const months = [
        "Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.",
        "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."
    ];

    const parts = dateString.split("-");
    if (parts.length < 3) {
        return dateString;
    }
    const year = parts[0];
    const month = months[parseInt(parts[1], 10) - 1];
    const day = parseInt(parts[2], 10);

    return `${month} ${day}, ${year}`;
}
